import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { take } from "rxjs/operators";
import { OrderPageComponent } from "src/app/frontoffice/order/orderpage/orderpage.component";
import { SaleMethodBranchModel } from "src/app/frontoffice/sales/model/sale-method-branch.model";

@Component({
  selector: "delino-notification",
  templateUrl: "./delino-notification.component.html",
  styleUrls: ["./delino-notification.component.scss"],
})
export class DelinoNotificationComponent extends BaseFormComponent<any> {
  saleMethodDelinoId: number;
  branchId = null;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public tabsservice: TabularService) {
    super(selectorService, cd);
  }

  async ngOnInit() {}

  close() {
    this.closeModal();
  }

  showNoti() {
    this.httpCommonService
      .get("SaleMethodBranch/GetDelinoSaleMethodBranch?BranchId=" + this.branchId)
      .pipe(take(1))
      .subscribe((data: SaleMethodBranchModel) => {
        if (!data) {
          this.close();
        }
        this.saleMethodDelinoId = data.Id;
        let saleMethodTitleName = "";
        saleMethodTitleName = data.SaleMethodTitle;
        let menu = <ITab>{
          title: saleMethodTitleName,
          isCloseable: true,
          icon: "{ icon: 'dashboard', pack: 'sepidzicon' }",
          active: true,
          responsive: true,
          data: [{ provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: data.Id, orderOnlinePage: true } }],
          componentType: OrderPageComponent,
          hasbadge: false,
        };
        const onlineOrderTabIndex = this.tabsservice.tabItemSubject.value.findIndex(
          (x) => x.data.find((z) => z.useValue.orderOnlinePage) || x.title === saleMethodTitleName
        );
        this.result = true;
        if (onlineOrderTabIndex > -1) {
          this.tabsservice.tabItemonRefreshData.next("Delino");
          this.tabsservice.setSelectedTab(onlineOrderTabIndex);
          this.close();
        } else {
          this.tabsservice.open(menu);
          this.close();
        }
      });
  }
}
